import * as React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

export class GenericModalProps {
    // Header
    title?: string | React.ReactNode;
    headerIcon?: React.ReactNode;

    // Body content
    body?: React.ReactNode;

    // Visibility and close
    isOpen?: boolean; // default: true
    onClose: () => void;
    showCloseButton?: boolean; // default: true

    // Two-button configuration
    okText?: string; // default: "Ok"
    okIcon?: React.ReactNode; // default: undefined (no icon)
    onOk: () => void;

    cancelText?: string; // default: "cancelar"

    // Styling
    className?: string; // default: "wide-dialog"
}

export function GenericModal(props: GenericModalProps): JSX.Element {
    const isOpen = props.isOpen !== false;
    const className = props.className || "wide-dialog";

    const closeButton = (props.showCloseButton !== false)
        ? <button className="btn-close" onClick={() => props.onClose()}>&nbsp;</button>
        : undefined;

    const bodyContent = typeof props.body === "string"
        ? <p>{props.body}</p>
        : props.body;

    const okText = props.okText ?? "Ok";
    const cancelText = props.cancelText ?? "Cancelar";

    return (
        <Modal isOpen={isOpen} className={className}>
            <ModalHeader close={closeButton}>
                {props.headerIcon && <span style={{ marginRight: 8 }}>{props.headerIcon}</span>}
                {props.title}
            </ModalHeader>

            <ModalBody>
                {bodyContent}
            </ModalBody>

            <ModalFooter>
                <Button
                    color="primary"
                    onClick={() => props.onOk()}>
                    {props.okIcon && <span style={{ marginRight: 6 }}>{props.okIcon}</span>}
                    {okText}
                </Button>

                <Button
                    color="secondary"
                    onClick={() => props.onClose()}>
                    {cancelText}
                </Button>
            </ModalFooter>
        </Modal>
    );
}
